module.exports = __webpack_public_path__ + "Pixel_2_icon.svg?2c2969ee1267743ee63abad44276ff4c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/Pixel_2_icon.svg
// module id = 209
// module chunks = 0